import type { Field } from "#gen/forms/v1/field_pb.js";
import type { Rule } from "#gen/forms/v1/forms_pb.js";

function incrementID(base: string): string {
	const index = base.lastIndexOf("_");
	const ordinal = Number.parseInt(base.substring(index + 1));
	if (Number.isNaN(ordinal)) {
		return base + "_1";
	}
	return base.substring(0, index) + "_" + (ordinal + 1);
}

export function generateId(fields: Field[], name: string): string {
	do {
		name = incrementID(name);
	} while (fields.findIndex(field => field.name == name) != -1);
	return name;
}

export function removeFieldFromRules(rules: Rule[], fieldName: string): Rule[] {
	return rules.reduce<Rule[]>((acc, rule) => {
		const schema = JSON.parse(rule.schema) as {
			anyOf?: Array<{ allOf?: Array<{ required?: string[] }> }>;
		};
		if (schema.anyOf) {
			const shouldKeep = schema.anyOf.every(option => {
				if (option.allOf) {
					return option.allOf.every(condition => {
						return !(condition.required && condition.required.includes(fieldName));
					});
				}
				return true;
			});
			if (!shouldKeep) {
				return acc;
			}
		}
		const cleanedKeys = rule.fieldKeys ? rule.fieldKeys.filter((key: string) => key !== fieldName) : rule.fieldKeys;
		acc.push({
			...rule,
			fieldKeys: cleanedKeys,
		});
		return acc;
	}, []);
}
